export function activityForModel (model) {
  if (model === 'join_instructions') {
    return null // join instructions don't have an activity they represent
  }

  return model.get('activity') || model
}

export function uniqueIdentifier (model) {
  if (!model) {
    return null
  }

  if (model === 'join_instructions') {
    return 'join_instructions'
  }

  if (model.get('activity')) {
    return `${uniqueIdentifier(model.get('activity'))}/${model.get('type')}`
  }

  return `${model.type()}/${model.get('permalink')}`
}

export function isSameModel (model1, model2) {
  return uniqueIdentifier(model1) === uniqueIdentifier(model2)
}
